<template>
  <div>
    <el-dialog 
      id="batchBalanceTransfer" 
      title="面单批量转移" 
      :visible.sync="isShow"  
      center  
      class="setCustomPrintImportTemplate common-dialog" 
      :close-on-click-modal="false" 
      width="1200px"
      @close="closeDialog">
      <div class="batch-transfer-container">
        <div class="add-transfer-section">
          <el-button type="primary" @click="addTransferItem" icon="el-icon-plus" :disabled="transferItems.length >= 10">添加面单转移</el-button>
          <span class="tip-text">已添加 {{ transferItems.length }} 个转移项</span>
          <span class="tip-text" v-if="transferItems.length >= 10" style="color: #F56C6C;">
            已达到最大转移项数量（10个）
          </span>
        </div>
        <div v-for="(item, index) in transferItems" :key="index" class="transfer-item">
          <div class="item-header">
            <span class="item-title">转移项【{{ index + 1 }}】</span>
            <el-button 
              type="danger" 
              icon="el-icon-delete" 
              size="mini" 
              @click="removeTransferItem(index)"
              :disabled="transferItems.length <= 1">删除</el-button>
          </div>
          
          <div class="transfer-content">
            <el-form :inline="true" :model="item.form" ref="transferForms" label-width="90px">
              <!-- 面单来源 -->
              <el-row>
                <div class="balanceTitle">面单来源</div>
              </el-row>
              <div class="y-mt-10">
                <el-row>
                  <el-form-item label="" class="customer-code">
                    <el-select 
                      v-model="item.form.balanceplatform.customerCode" 
                      placeholder="请选择客户编码" 
                      @change="((val)=>{changeSourceKcode(val, index)})"
                      class="select-style">
                      <el-option 
                        v-for="(obj, idx) in tableData" 
                        :key="idx" 
                        :label="obj.code + '-' + obj.name" 
                        :value="obj.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="balanceplatform" label="" class="select-label">
                    <el-select 
                      v-model="item.form.balanceplatform.platform" 
                      placeholder="请选择平台" 
                      @change="((val)=>{platformChange(val, 'balanceplatform', index)})"
                      class="select-style">
                      <el-option 
                        v-for="(obj, idx) in item.form.balanceplatform.selectPlatformList" 
                        :key="idx+'|'+obj.code" 
                        :label="obj.name" 
                        :value="obj.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="balanceplatform" label="" class="select-label">
                    <el-select 
                      v-model="item.form.balanceplatform.serviceCode" 
                      placeholder="请选择服务" 
                      @change="((val)=>{codServiceChange(val, 'balanceplatform', index)})"
                      class="select-style">
                      <el-option label="普通" value=""></el-option>
                      <el-option 
                        label="COD" 
                        value="YTOCOD" 
                        v-if="item.form.balanceplatform.platform=='YTO'&&item.form.balanceplatform.isCod=='Y'">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="balanceplatform" label="" class="select-label">
                    <el-select 
                      v-model="item.form.balanceplatform.sellerCode" 
                      placeholder="请选择客户/商家" 
                      filterable 
                      @change="((val)=>{shopChange(val, 'balanceplatform', index)})"
                      class="select-style">
                      <el-option 
                        v-for="(obj, idx) in item.form.balanceplatform.sellerList" 
                        :key="idx+'|'+obj.sellerId" 
                        :label="obj.sellerNick" 
                        :value="obj.sellerId">
                      </el-option>
                    </el-select>
                    <span class="y-ml-10" v-if="item.form.balanceplatform.sellerCode">
                      余额：{{ item.form.balanceplatform.amount }}
                    </span>
                  </el-form-item>
                </el-row>
              </div>
              
              <!-- 面单转出 -->
              <el-row>
                <div class="balanceTitle">面单转出到</div>
              </el-row>
              <div class="y-mt-10">
                <el-row>
                  <el-form-item label="" class="customer-code">
                    <el-select 
                      v-model="item.form.balanceOutplatform.customerCode" 
                      placeholder="请选择客户编码" 
                      @change="((val)=>{changeKcode(val, index)})" 
                      class="select-style">
                      <el-option 
                        v-for="(obj, idx) in item.kList" 
                        :key="idx" 
                        :label="obj.customerCode + '-' + obj.customerName" 
                        :value="obj.customerCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="balanceOutplatform" label="" class="select-label">
                    <el-select 
                      v-model="item.form.balanceOutplatform.platform" 
                      placeholder="请选择平台" 
                      @change="((val)=>{platformChange(val, 'balanceOutplatform', index)})" 
                      class="select-style">
                      <el-option 
                        v-for="(obj, idx) in item.form.balanceOutplatform.selectPlatformList" 
                        :key="idx" 
                        :label="obj.name" 
                        :value="obj.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="balanceOutplatform" label="" class="select-label">
                    <el-select 
                      v-model="item.form.balanceOutplatform.serviceCode" 
                      placeholder="请选择服务" 
                      @change="((val)=>{codServiceChange(val, 'balanceOutplatform', index)})" 
                      class="select-style">
                      <el-option label="普通" value=""></el-option>
                      <el-option 
                        label="COD" 
                        value="YTOCOD" 
                        v-if="item.form.balanceOutplatform.platform=='YTO'&&item.form.balanceOutplatform.isCod=='Y'">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="balanceOutplatform" label="" class="select-label">
                    <el-select 
                      v-model="item.form.balanceOutplatform.sellerCode" 
                      placeholder="请选择客户/商家" 
                      filterable 
                      @change="((val)=>{shopChange(val, 'balanceOutplatform', index)})" 
                      class="select-style">
                      <el-option 
                        v-for="(obj, idx) in item.form.balanceOutplatform.sellerList" 
                        :key="idx+'|'+obj.sellerId" 
                        :label="obj.sellerNick" 
                        :value="obj.sellerId">
                      </el-option>
                    </el-select>
                    <span class="y-ml-10" v-if="item.form.balanceOutplatform.sellerCode">
                      余额：{{ item.form.balanceOutplatform.amount }}
                    </span>
                  </el-form-item>
                </el-row>
              </div>
              
              <!-- 转出数量 -->
              <el-row>
                <div class="balanceTitle">转出数量</div>
              </el-row>
              <div class="padingTop10">
                <el-row>
                  <el-form-item label="" id="number">
                    <el-input-number 
                      type="number" 
                      v-model="item.form.quantity" 
                      :min="1" 
                      :max="10000" 
                      :precision="0" 
                      @blur="limitPrintNum(index)">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="">
                    <span 
                      class="y-fc-4C84FF y-c-p" 
                      @click="transferAllQuantityFn(index)">
                      全部转出
                    </span>
                  </el-form-item>
                </el-row>
              </div>
            </el-form>
          </div>
        </div>
        
        <el-row class="padingTop18 tocenter submitbtn">
          <el-button @click="closeDialog" class="y-fc-333 y-fw-400">取消</el-button>
          <el-button type="primary" @click="confirmBatchTransferFn" :loading="submitLoading">确定批量转移</el-button>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  selectPlatformApi, 
  getMallsAndRechargeApi, 
  getTransferOutKcodeListApi, 
  transferOutSubmitBatchApi 
} from '../../../../../api/baseInfo/printSetting/faceBillBalanceSearch';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    fromParentVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      isShow: true,
      transferItems: [],
      submitLoading: false
    };
  },
  mounted() {
    console.log('333',this.isShow);
    this.initTransferItems();
  },
  methods: {
    // 初始化转移项
    initTransferItems() {
      this.transferItems = [{
        form: {
          balanceplatform: {
            customerCode: '',
            customerName: '',
            sellerCode: '',
            platform: '',
            serviceCode: '',
            sellerName: '',
            platformName: '',
            amount: '',
            selectPlatformList: [],
            sellerList: [],
            isCod: 'N'
          },
          balanceOutplatform: {
            customerCode: '',
            customerName: '',
            sellerCode: '',
            platform: '',
            serviceCode: '',
            sellerName: '',
            platformName: '',
            amount: '',
            selectPlatformList: [],
            sellerList: [],
            isCod: 'N'
          },
          quantity: 0
        },
        kList: []
      }];
      // 如果需要为初始项设置默认值或加载数据，可以在这里处理
      // 例如：this.selectPlatform('balanceplatform', defaultObj.code, 0);
    },
    
    // 添加新的转移项
    addTransferItem() {
      // 限制最多添加10个转移项
      if (this.transferItems.length >= 10) {
        this.$message.warning('最多只能添加10个转移项');
        return;
      }
      
      this.transferItems.push({
        form: {
          balanceplatform: {
            customerCode: '',
            customerName: '',
            sellerCode: '',
            platform: '',
            serviceCode: '',
            sellerName: '',
            platformName: '',
            amount: '',
            selectPlatformList: [],
            sellerList: [],
            isCod: 'N'
          },
          balanceOutplatform: {
            customerCode: '',
            customerName: '',
            sellerCode: '',
            platform: '',
            serviceCode: '',
            sellerName: '',
            platformName: '',
            amount: '',
            selectPlatformList: [],
            sellerList: [],
            isCod: 'N'
          },
          quantity: 0
        },
        kList: []
      });
      
      // 初始化平台数据
      // const newIndex = this.transferItems.length - 1;
      // // this.selectPlatform('balanceplatform', defaultObj.code, newIndex);
    },
    
    // 删除转移项
    removeTransferItem(index) {
      if (this.transferItems.length <= 1) {
        this.$message.warning('至少保留一个转移项');
        return;
      }
      this.transferItems.splice(index, 1);
    },

    changeSourceKcode(customerCode, index) {
      const item = this.transferItems[index];
      const selectedCustomer = this.tableData.find(data => data.code === customerCode);
      
      if (selectedCustomer) {
        item.form.balanceplatform.customerName = selectedCustomer.name;
        item.form.balanceplatform.platform = '';
        item.form.balanceplatform.sellerCode = '';
        item.form.balanceplatform.sellerName = '';
        item.form.balanceplatform.amount = '';
        this.selectPlatform('balanceplatform', customerCode, index);
      }
      // 清空balanceOutplatform
      item.form.balanceOutplatform = {
        customerCode: '',
        customerName: '',
        sellerCode: '',
        platform: '',
        serviceCode: '',
        sellerName: '',
        platformName: '',
        amount: '',
        selectPlatformList: [],
        sellerList: [],
        isCod: 'N'
      };
      // 清空kList
      item.kList = [];
      this.getKList(index);
    },
    // 查看平台
    selectPlatform(prop, kcode, index) {
      selectPlatformApi({
        kcode: kcode,
        loginId: this.userMess.loginId,
        groupId: this.userMess.groupId
      }).then(res => {
        if (res.success) {
          this.transferItems[index].form[prop].selectPlatformList = res.data.platformList || [];
        } else {
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.error);
      });
    },
    
    // 平台切换
    platformChange(val, prop, index) {
      const item = this.transferItems[index];
      item.form[prop].sellerList = [];
      const platform = item.form[prop].selectPlatformList.find(element => element.code === val);
      
      if (platform) {
        item.form[prop].platformName = platform.name;
        item.form[prop].isCod = platform.isCod || 'N';
      }
      
      item.form[prop].serviceCode = '';
      item.form[prop].sellerCode = '';
      item.form[prop].sellerName = '';
      item.form[prop].amount = '';
      this.selectShopByCondition(val, prop, index);
    },
    
    // 获取店铺
    selectShopByCondition(platform, prop, index) {
      const item = this.transferItems[index];
      
      if (platform !== 'YTO') {
        const params = {
          kcode: item.form[prop].customerCode,
          channel: platform,
          loginId: this.userMess.loginId,
          groupId: this.userMess.groupId
        };
        
        getMallsAndRechargeApi(params).then(res => {
          if (res.success) {
            item.form[prop].sellerList = res.data.mallBalanceList || [];
          } else {
            this.$message.error(res.message);
          }
        }).catch((err) => {
          this.$message.error(err.error);
        });
      } else {
        item.form[prop].sellerList = [];
        const list = this.tableData.filter(o => o.code == item.form[prop].customerCode);
        item.form[prop].sellerList = list.map(o => {
          return {
            sellerId: o.code,
            sellerNick: o.code + '-' + o.name,
            quantity: o.newWaybillCount,
            codeQuantity: o.codWaybillCount
          };
        });
        
        if (item.form[prop].sellerList.length > 0) {
          item.form[prop].sellerCode = item.form[prop].sellerList[0].sellerId;
          this.shopChange(item.form[prop].sellerList[0].sellerId, prop, index);
        }
      }
    },
    
    codServiceChange(val, prop, index) {
      const item = this.transferItems[index];
      if (item.form[prop].sellerCode) {
        this.shopChange(item.form[prop].sellerCode, prop, index);
      } else {
        item.form[prop].sellerCode = '';
        item.form[prop].sellerName = '';
        item.form[prop].amount = '';
      }
    },
    
    shopChange(val, prop, index) {
      const item = this.transferItems[index];
      const seller = item.form[prop].sellerList.find(element => element.sellerId === val);
      
      if (seller) {
        item.form[prop].sellerName = seller.sellerNick;
        item.form[prop].amount = item.form[prop].serviceCode == 'YTOCOD' ? 
          seller.codeQuantity : seller.quantity;
      }
    },
    
    // 只能输入数字其他屏蔽
    limitPrintNum(index) {
      const item = this.transferItems[index];
      if (item.form.quantity === '' || item.form.quantity === undefined) {
        item.form.quantity = 0;
      }
    },
    
    // 查询客户编码列表
    getKList(index) {
      const item = this.transferItems[index];
      console.log(item.form.balanceplatform.customerCode);
      getTransferOutKcodeListApi(item.form.balanceplatform.customerCode).then(res => {
        if (res.message === 'ok') {
          item.kList = res.data || [];
          item.kList.forEach(o => {
            o.customerCode = o.customerCode ? o.customerCode.replace(/(^\s*)|(\s*$)/g, '') : '';
          });
        } else {
          item.kList = [];
          this.$message.error(res.error);
        }
      }).catch(err => {
        item.kList = [];
        this.$message.error(err.error);
      });
    },
    
    // 切换k码
    changeKcode(kcode, index) {
      const item = this.transferItems[index];
      const kCodeList = item.kList.filter(o => o.customerCode == item.form.balanceOutplatform.customerCode);
      
      if (kCodeList.length > 0) {
        item.form.balanceOutplatform.customerName = kCodeList[0].customerName;
        item.form.balanceOutplatform.platform = '';
        item.form.balanceOutplatform.sellerCode = '';
        item.form.balanceOutplatform.sellerName = '';
        item.form.balanceOutplatform.amount = '';
        this.selectPlatform('balanceOutplatform', kcode, index);
      }
    },
    
    // 关闭dialog
    closeDialog() {
      this.isShow = false;
      this.$emit('update:fromParentVisible', false);
    },
    
    // 全部转出
    transferAllQuantityFn(index) {
      const item = this.transferItems[index];
      if (!item.form.balanceOutplatform.sellerCode) {
        this.$message.error('请选择转出客户/商家信息');
        return false;
      }
      item.form.quantity = item.form.balanceplatform.amount;
    },
    
    // 确认批量转移
    async confirmBatchTransferFn() {
      // 验证所有表单项
      // 检查是否有重复的转移路径（防止循环转移）
      const transferPaths = [];
      for (let i = 0; i < this.transferItems.length; i++) {
        const item = this.transferItems[i];
        
        if (!item.form.balanceplatform.sellerCode) {
          this.$message.error(`第${i+1}项：请选择客户/商家信息`);
          return false;
        }
        
        if (!(item.form.balanceplatform.amount > 0)) {
          this.$message.error(`第${i+1}项：面单余额为0，不可转移`);
          return false;
        }
        
        if (!item.form.quantity) {
          this.$message.error(`第${i+1}项：请输入转出数量`);
          return false;
        }
        
        // if (item.form.balanceplatform.platform == item.form.balanceOutplatform.platform && 
        //     item.form.balanceplatform.serviceCode == item.form.balanceOutplatform.serviceCode &&
        //     item.form.balanceplatform.sellerCode == item.form.balanceOutplatform.sellerCode) {
        //   this.$message.error(`第${i+1}项：请勿重复选择`);
        //   return false;
        // }
        
        if (!item.form.balanceOutplatform.sellerCode) {
          this.$message.error(`第${i+1}项：请选择转出客户/商家信息`);
          return false;
        }
        // 构造唯一的转移路径标识符
        const fromKey = `${item.form.balanceplatform.customerCode}|${item.form.balanceplatform.platform}|${item.form.balanceplatform.serviceCode}|${item.form.balanceplatform.sellerCode}`;
        const toKey = `${item.form.balanceOutplatform.customerCode}|${item.form.balanceOutplatform.platform}|${item.form.balanceOutplatform.serviceCode}|${item.form.balanceOutplatform.sellerCode}`;
        
        // 检查是否为自循环（同一店铺内转移）
        if (fromKey === toKey) {
          this.$message.error(`第${i+1}项：相同店铺之间不能转移`);
          return false;
        }
        
        // 检查是否与其他转移项形成循环
        const currentPath = `${fromKey}->${toKey}`;
        const reversePath = `${toKey}->${fromKey}`;
        
        if (transferPaths.includes(reversePath)) {
          this.$message.error(`第${transferPaths.indexOf(reversePath)+1}项与第${i+1}项：不同店铺之间不可以同时转入转出`);
          return false;
        }
        
        transferPaths.push(currentPath);
      }
      
      try {
        await this.$confirm('请确认是否批量转移面单，面单转移后不可撤回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      
      this.submitLoading = true;
      
      let params = [];
      this.transferItems.forEach(item => {
        let obj = {
          // 面单来源信息
          fromCustomerCode: item.form.balanceplatform.customerCode,
          fromCustomerName: item.form.balanceplatform.customerName,
          fromTerraceCode: item.form.balanceplatform.platform,
          fromTerraceName: item.form.balanceplatform.platformName,
          fromServiceCode: item.form.balanceplatform.serviceCode == 'YTOCOD' ? 'YTOCOD' : 'COMMON',
          fromServiceName: item.form.balanceplatform.serviceCode == 'YTOCOD' ? '圆通COD' : '普通',
          fromSellerCode: item.form.balanceplatform.sellerCode,
          fromSellerName: item.form.balanceplatform.sellerName,
          // 面单转出信息
          allotToCode: item.form.balanceOutplatform.customerCode,
          allotToName: item.form.balanceOutplatform.customerName,
          terraceCode: item.form.balanceOutplatform.platform,
          terraceName: item.form.balanceOutplatform.platformName,
          serviceCode: item.form.balanceOutplatform.serviceCode == 'YTOCOD' ? 'YTOCOD' : 'COMMON',
          serviceName: item.form.balanceOutplatform.serviceCode == 'YTOCOD' ? '圆通COD' : '普通',
          sellerCode: item.form.balanceOutplatform.sellerCode,
          sellerName: item.form.balanceOutplatform.sellerName,
          transferQty: item.form.quantity,
          operateSource: 1 // 1 客户管家 2 app
        };
        params.push(obj);
      });
      
      console.log('params----',params);
      // 调用一次接口传递整个参数数组
      transferOutSubmitBatchApi(params).then(res => {
        if (res.message === 'ok' && res.data && res.data.checkMsgList && res.data.checkMsgList.length) {
          let checkResults  = JSON.parse(JSON.stringify(res.data.checkMsgList));
          let failedItems = [];
          let successCount = checkResults.filter(item => item.status === "success").length;
          let failCount = checkResults.length - successCount;
          // 收集失败项信息
          checkResults.forEach((item,index) => {
            if(item.status == "fail") {
              let failStr = '转移项【'+(index+1)+'】：'+item.checkMsgList[0].replace(/\n/g, '<br/>');
              failedItems.push(failStr);
            }
          });
          let msgTitle =  `面单转移&nbsp;<span style="color:#333;font-weight:bold">${checkResults.length}</span>&nbsp;项，` + 
                          `成功:&nbsp;<span style="color:green;font-weight:bold">${successCount}</span>&nbsp;项，` + 
                          `失败:&nbsp;<span style="color:red;font-weight:bold">${failCount}</span>&nbsp;项<br/>`;
          let msgContent = '';
          if(failedItems.length > 0) {
            msgContent = '转移失败项:<br/>' + failedItems.join('<br/>') + '<br/>';
          }
          if(successCount > 0){
            this.$confirm(msgTitle+msgContent+`成功面单正在转移，预计需要3分钟，转移结果请在面单转移记录去查询`, '提示', {
              confirmButtonText: '去查询',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.handleTransferComplete(true);
            }).catch(() => {
              this.handleTransferComplete(false);
            });
          }else{
            this.$alert(msgTitle+msgContent, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
            });
          }
        } else {
          this.$message.error(`面单批量转移失败`);
        }
      }).catch(err => {
        this.$message.error('面单批量转移失败');
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    // 处理转移完成后的操作
    handleTransferComplete(goToRecord) {
      this.closeDialog();
      this.$emit('success');
      
      // 如果需要跳转到记录页面
      if (goToRecord && this.$parent && typeof this.$parent.showBalanceRecode !== 'undefined') {
        this.$parent.showBalanceRecode = true;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../../../../styles/variables";

#batchBalanceTransfer {
  .batch-transfer-container {
    max-height: 60vh;
    overflow-y: auto;
    
    .add-transfer-section {
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      margin-bottom: 20px;
      
      .tip-text {
        margin-left: 15px;
        color: #999;
      }
    }
    
    .transfer-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 15px;
      
      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;
        
        .item-title {
          font-weight: bold;
          font-size: 16px;
          color: #333;
        }
      }
      
      .transfer-content {
        .balanceTitle::before {
          position: absolute;
          content: " ";
          height: 10px;
          left: 0px;
          border: 2px solid $blue-style;
        }
        
        .balanceTitle {
          margin-left: 10px;
        }
      }
    }
  }
  
  .el-table {
    .el-table__body-wrapper {
      max-height: 559px !important;
    }
    .cell {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .add-btn{
    background: $blue-style;
    border-radius: 3px;
    color: #ffffff;
    border: 1px solid $blue-style;
  }
  .padingTop18{
    padding-top: 18px;
    .el-form-item__label{
      color: #666666;
      font-weight: 400;
      line-height: 34px;
    }
    .el-form-item__content{
      color: #333333;
      font-weight: 400;
      line-height: 34px;
    }
  }
  .tocenter{
    text-align: center;
    padding-bottom: 20px;
  }
  .padingTop10{
    padding-top: 15px;
    .el-form-item__label{
      color: #666666;
      font-weight: 400;
      line-height: 34px;
    }
    .el-form-item__content{
      color: #333333;
      font-weight: 400;
      line-height: 34px;
    }
  }
  .select-style{
    width: 200px;
    height: 34px;
    border-radius: 4px;
  }
  .customer-code .el-form-item__label{
    color: #333333;
    font-weight: 600;
  }
  .customer-code .el-form-item__content{
    color: #333333;
    font-weight: 600;
  }
}

#batchBalanceTransfer .el-input,
#batchBalanceTransfer .el-input .el-input__inner {
  width: 200px;
}
.select-style .el-input,
.select-style .el-input .el-input__inner {
  height: 34px !important;
}
#number .el-input,
#number .el-input .el-input__inner {
  width: 130px;
  height: 34px;
}
#number .el-form-item__content,
#number .el-input-number--small {
  width: 130px;
}

#number{
  line-height: 32px;
  .el-input-number__decrease,.el-input-number__increase{
    height: 32px;
    line-height: 32px;
  }
  .select-label{
    line-height: 32px;
  }
}
.submitbtn .el-button{
  height: 40px;
  width: auto;
  min-width: 100px;
  border-radius: 3px;
  // font-size: 20px;
}
</style>